import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import clsx from "clsx";
// Colour is a rule of its own rather than a props-dependent value, so that the
// sheet stays static and its class names survive a remount - see
// components/generateClassName.
const useStyles = makeStyles((theme) => ({
    root: {
        textAlign: "center",
        fontSize: "30px",
        fontWeight: 500,
        lineHeight: "1.1em",
        marginBottom: theme.spacing(4),
        marginTop: theme.spacing(0),
        [theme.breakpoints.down("sm")]: {
            fontSize: "20px",
            marginBottom: theme.spacing(2),
        },
    },
    // Stupid with important, but desktop has overrides :/
    colorPrimary: {
        color: theme.palette.primary.dark + " !important",
    },
    colorSecondary: {
        color: theme.palette.secondary.main + " !important",
    },
}));
export const Level2BoxHeading = ({ color = "secondary", children, }) => {
    const classes = useStyles();
    return (React.createElement("h2", { className: clsx(classes.root, color === "secondary" ? classes.colorSecondary : classes.colorPrimary) }, children));
};
